module.exports = __webpack_public_path__ + "img/banktransfer.84ed3f48.svg";